export default __webpack_public_path__ + "static/media/element_28.3fc73945.avif";